import { FEATURES, type Feature } from './feature-flags.types';

/**
 * Kill-switch flags for on-device MCP templates, keyed by template id —
 * bundled and backend-catalog ids share one namespace. A template absent from
 * this table is always available; one entry here gates every surface at once
 * (tiles, installed cards, manifest advertisement, spawn, connection tests).
 *
 * Lives in `electron/shared` because both the renderer and main read it. Not
 * re-exported from the barrel on purpose.
 */
export const MCP_TEMPLATE_FEATURE_FLAGS: Readonly<Record<string, Feature>> = {
  'computer-use': FEATURES.AXON_COMPUTER_USE,
  'outlook-local': FEATURES.AXON_OUTLOOK_LOCAL,
};

export function featureFlagForTemplate(
  templateId: string | undefined
): Feature | undefined {
  return templateId ? MCP_TEMPLATE_FEATURE_FLAGS[templateId] : undefined;
}

export function isTemplateAllowed(
  templateId: string | undefined,
  hasFeature: (feature: Feature) => boolean
): boolean {
  const flag = featureFlagForTemplate(templateId);
  return flag === undefined || hasFeature(flag);
}

export function gatedTemplateIds(): readonly string[] {
  return Object.keys(MCP_TEMPLATE_FEATURE_FLAGS);
}

export { templateIdForServer } from '@littlebird/axon-mcp/contract';
